/**
 * RouteSuspenseFallback.jsx — Fallback discret pour <Suspense> autour des routes lazy.
 *
 * Perf (perf/2026-07-05-route-code-splitting) : les composants de ROUTE sont chargés en
 * React.lazy (code-splitting) → ce fallback s'affiche pendant la résolution du chunk d'une
 * page. Réutilise le MÊME anneau de spinner que le middleware loading (LoadingProvider) pour
 * une cohérence DA totale (COLORS.accent, RADII.circle), SANS le backdrop sombre plein écran
 * (pas de flash noir à chaque navigation) : un simple anneau centré dans la zone de route.
 *
 * §12 terdecies — aucun dialog natif. §11/§18 — compose les tokens DA réels (theme.js).
 * §12 quinquies — bords arrondis (cercle). Zéro logique métier : purement présentationnel.
 */
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { COLORS, RADII } from '../theme';

const spin = keyframes`to { transform: rotate(360deg); }`;

/* Zone centrée dans le flux de la page (pas de position:fixed → pas de recouvrement du header,
   pas de backdrop). min-height calée pour occuper l'espace sous le header pendant le chargement
   du chunk, évitant un saut de layout brutal. */
const Wrap = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Ring = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border: 0.25rem solid rgba(194, 24, 166, 0.2);
  border-top-color: ${COLORS.accent};
  border-radius: ${RADII.circle};
  animation: ${spin} 0.85s linear infinite;
`;

/**
 * RouteSuspenseFallback — rendu par <Suspense fallback={...}> le temps qu'un chunk de route
 * lazy soit téléchargé + parsé. Discret par design (pas de texte, pas de backdrop).
 */
const RouteSuspenseFallback = () => (
  <Wrap role="status" aria-live="polite" aria-label="Loading">
    <Ring />
  </Wrap>
);

export default RouteSuspenseFallback;
